import { NgModule } from '@angular/core';
import { OptionModule } from '../abstract/option.module';
import { OptionAfterschoolComponent } from './option-afterschool.component';

@NgModule({
  imports: [OptionModule],
  declarations: [OptionAfterschoolComponent],
  exports: [OptionAfterschoolComponent]
})
export class OptionAfterschoolModule {}
